import { Modal, Timeline, Typography, Tag } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";

const { Text } = Typography;

const themeColor = "rgb(0, 84, 157)";

const CaseLogsSummaryCountModal = ({ open, onClose, caseLogs = [] }: any) => {
  return (
    <Modal
      title={
        <span style={{ color: themeColor, fontWeight: 600 }}>Case Logs</span>
      }
      open={open}
      footer={null}
      onCancel={onClose}
      width={950}
    >
      <div
        style={{
          maxHeight: "500px",
          overflowY: "auto",
          padding: "4px 8px",
        }}
      >
        <Timeline
          mode="left"
          items={caseLogs?.map((item: any) => ({
            color: themeColor,
            dot: <ClockCircleOutlined style={{ color: themeColor }} />,
            children: (
              <div
                style={{
                  background: "#f5f9ff",
                  padding: "12px 16px",
                  borderRadius: "8px",
                  borderLeft: `4px solid ${themeColor}`,
                }}
              >
                <div style={{ marginBottom: 6 }}>
                  <Tag color="blue">Registration Id.: {item.registrationId}</Tag>
                </div>

                <Text strong>{item.process || "No Process"}</Text>

                <div style={{ marginTop: 4 }}>
                  <Text type="secondary">
                    Status: {item.status || "N/A"}
                  </Text>
                </div>

                <div>
                  <Text type="secondary">
                    Raised Date: {item.raisedDate || "N/A"}
                  </Text>
                </div>

                <div>
                  <Text type="secondary">
                    Remarks: {item.remarks || "N/A"}
                  </Text>
                </div>

                {item.amount && (
                  <div>
                    <Text type="secondary">Amount: {item.amount}</Text>
                  </div>
                )}

                {item.remarks && item.remarks !== "NA" && (
                  <div style={{ marginTop: 6 }}>
                    <Text>Remarks: {item.remarks}</Text>
                  </div>
                )}
              </div>
            ),
          }))}
        />
      </div>
    </Modal>
  );
};

export default CaseLogsSummaryCountModal;